<template>
  <div>
    <div>{{ total }}</div>
  </div>
</template>

<script>
  export default {
    name: "TotalCommissionCell",
    props: {
      data: Object,
    },
    computed: {
      total() {
        if (!this.data.sum || !this.data.partnerCommission) return '-'
        const result = parseFloat(this.data.sum) + parseFloat(this.data.partnerCommission)
        return result.toFixed(2)
      }
    }
  }
</script>

<style scoped>

</style>
